import React from "react";
import styled from "styled-components";

import Button from "@ingka/button";
import information from "@ingka/ssr-icon/paths/document-pencil";
import ListView, { ListViewItem, ListViewItemControlProps } from "@ingka/list-view";
import { colourNeutral4, colourStaticBlack, colourStaticIkeaBrandYellow } from "@ingka/variables/colours-css";
import play from "@ingka/ssr-icon/paths/play";
import wrench from "@ingka/ssr-icon/paths/wrench";
import documentCheckmark from "@ingka/ssr-icon/paths/document-checkmark";
import Modal, { ModalHeader, Prompt } from "@ingka/modal";
import { space400, space550 } from "@ingka/variables/design-tokens";

import Feedback from "../Feedback/Feedback";
import { FLAGGA_VIDEO_ONBOARDING_URL, DIGITAL_BUSINESS_SUPPORT_URL } from "../../utils/constants";

const FloatingButton = styled(Button)`
	position: fixed;
	z-index: 100;
	bottom: 0.8rem;
	right: 3rem;
	box-shadow: 0px 0px 0px 1px ${colourNeutral4}, 0px 4px 8px 0px ${colourStaticBlack};
`;

const FeedbackPrompt = styled(Prompt)`
	position: fixed;
	bottom: ${space550};
	right: ${space400};
	.prompt__content {
		padding: 0;
	}
	.prompt__heading {
		text-align: center;
	}
`;

const CustomModalHeader = styled(ModalHeader)`
	background-color: ${colourStaticIkeaBrandYellow};
	& .btn__inner {
		background-color: ${colourStaticIkeaBrandYellow};
	}
`;

interface FloatingMenuProps {
	showFloatingMenu: boolean;
	showFeedbackModal: boolean;
	setShowFloatingMenu: (value: boolean) => void;
	setShowFeedbackModal: (value: boolean) => void;
}

const Layout: React.FC<FloatingMenuProps> = ({
	showFloatingMenu,
	showFeedbackModal,
	setShowFloatingMenu,
	setShowFeedbackModal,
}) => {
	return (
		<>
			<FloatingButton
				iconOnly
				title="Feedback"
				type="emphasised"
				ssrIcon={information}
				onClick={() => setShowFloatingMenu(true)}
				aria-haspopup="dialog"
			/>
			<Modal visible={showFloatingMenu} handleCloseBtn={() => setShowFloatingMenu(false)}>
				<FeedbackPrompt title="Welcome to Flagga" titleId="" header={<CustomModalHeader />} footer={null}>
					<ListView id="floating-menu-popup" showDivider={false} size="small">
						<ListViewItem
							key="feedback"
							inset
							title="Feedback"
							control="navigational"
							controlIcon="chevronRightSmall"
							emphasised
							leadingIcon={documentCheckmark}
							name="Feedback-option-review"
							onClick={() => {
								setShowFeedbackModal(true);
								setShowFloatingMenu(false);
							}}
							tabIndex={0}
							data-autofocus
							aria-haspopup="dialog"
						/>
						<ListViewItem
							key="feature-improvements"
							inset
							title="Feature improvements"
							aria-label="Raise a ticket for feature improvement request (opens in a new tab)"
							control="link"
							controlIcon="chevronRightSmall"
							emphasised
							leadingIcon={wrench}
							name="feature-imrpovements"
							target="_blank"
							href={DIGITAL_BUSINESS_SUPPORT_URL}
							onClick={() => {
								setShowFloatingMenu(false);
							}}
						/>
						<ListViewItem
							id="onboarding-video"
							inset
							title="Onboarding video"
							aria-label="Watch flagga onboarding video (opens in a new tab)"
							control="link"
							emphasised
							controlIcon="chevronRightSmall"
							leadingIcon={play}
							name="Feedback-option-video"
							target="_blank"
							href={FLAGGA_VIDEO_ONBOARDING_URL}
							onClick={() => {
								setShowFloatingMenu(false);
							}}
						/>
					</ListView>
				</FeedbackPrompt>
			</Modal>
			<Feedback
				showRating={false}
				showModalFromFloatingMenu={showFeedbackModal}
				setShowModalFromFloatingMenu={setShowFeedbackModal}
			/>
		</>
	);
};

export default Layout;
